import React from "react";

import { Box, Typography } from "@mui/material";

import image from "./elements.svg";

// ---------------------------------------------------------------------------------------------------------------------
export default function CerebroAttentionBanner() {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        padding: 1.5,
        gap: 2,
        background: "#32383E",
        borderRadius: "8px",
        color: "white",
      }}>
      <Box>
        <img src={image} alt={"log"} />
      </Box>
      <Typography sx={{ color: "white" }}>
        Включен режим «ЦЕРЕБРО»: данные по заказам рассчитываются альтернативным способом, а не по
        остаткам. Часть аналитических срезов в этом режиме скрыта. Вы всегда можете выключить
        «ЦЕРЕБРО» и переключиться на обычный режим с выручкой по остаткам.
      </Typography>
    </Box>
  );
}
